/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Art_3_StateInputs */

const en_services_svc_agents_art_3_state = /** @type {(inputs: Services_Svc_Agents_Art_3_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-off`)
};

const lv_services_svc_agents_art_3_state = /** @type {(inputs: Services_Svc_Agents_Art_3_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināt`)
};

/**
* | output |
* | --- |
* | "Sign-off" |
*
* @param {Services_Svc_Agents_Art_3_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_art_3_state = /** @type {((inputs?: Services_Svc_Agents_Art_3_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Art_3_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_art_3_state(inputs)
	return en_services_svc_agents_art_3_state(inputs)
});